// extracted by mini-css-extract-plugin
export default {"r_mega_menu":"right-side-bar_r_mega_menu__UVas9","r_mega_menu_icon":"right-side-bar_r_mega_menu_icon__T5nxn"};